import React from 'react';

export interface EstrellaIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const EstrellaIcon: React.FC<EstrellaIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m12.826 2.333 3.219 6.52 7.198 1.053-5.209 5.073 1.23 7.166-6.438-3.385-6.437 3.385 1.229-7.166-5.209-5.073 7.198-1.052z"/>
    </svg>
  );
};

export default EstrellaIcon;
